import React, { useState, useEffect } from "react";
import { Modal, Input, message } from "antd";
import authApi from "../../../api/authApi";

/**
 * Modal for deducting money from a user's balance (fraud/admin adjustment).
 * Props:
 *   user       - selected user record (null = hidden)
 *   onClose    - close without action
 *   onSuccess  - called after successful deduction
 */
function UserDeductModal({ user, onClose, onSuccess }) {
    const [amount, setAmount] = useState("");
    const [reason, setReason] = useState("");
    const [loading, setLoading] = useState(false);

    // Reset form whenever a new user is selected
    useEffect(() => {
        if (user) { setAmount(""); setReason(""); }
    }, [user]);

    const handleSubmit = async () => {
        if (!amount || !reason.trim()) {
            message.error("Vui lòng nhập đầy đủ thông tin");
            return;
        }
        const numAmount = parseFloat(amount);
        if (numAmount <= 0) { message.error("Số tiền phải lớn hơn 0"); return; }
        if (numAmount > user.cash) { message.error("Số tiền trừ vượt quá số dư hiện tại"); return; }

        setLoading(true);
        try {
            await authApi.deductFraudMoney(user.id, numAmount, reason.trim());
            message.success("Đã trừ tiền thành công");
            onSuccess();
        } catch (error) {
            message.error(error.response?.data?.message || "Không thể trừ tiền");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Điều chỉnh số dư tài khoản"
            open={Boolean(user)}
            onOk={handleSubmit}
            onCancel={onClose}
            okText="Xác nhận trừ tiền"
            okButtonProps={{ danger: true, loading }}
            cancelText="Hủy"
            destroyOnClose
        >
            {user && (
                <div className="flex flex-col gap-4 py-2">
                    <div>
                        <p className="text-xs text-content-3 mb-1">Người dùng</p>
                        <p className="font-semibold">ID {user.id} – {user.name}</p>
                        <p className="text-sm text-content-3">{user.email}</p>
                    </div>
                    <div>
                        <p className="text-xs text-content-3 mb-1">Số dư hiện tại</p>
                        <p className="font-bold text-green-600">{user.cash?.toLocaleString("vi-VN")}đ</p>
                    </div>
                    <div>
                        <p className="text-xs text-content-3 mb-1">Số tiền cần trừ (đ)</p>
                        <Input
                            type="number"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            placeholder="Nhập số tiền"
                            min="1"
                            max={user.cash}
                        />
                    </div>
                    <div>
                        <p className="text-xs text-content-3 mb-1">Lý do</p>
                        <Input.TextArea
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            placeholder="Nhập lý do trừ tiền"
                            rows={3}
                        />
                    </div>
                </div>
            )}
        </Modal>
    );
}

export default UserDeductModal;
